/*
  Delay home banner video link for 3 seconds
*/

export function delayHomeBannerVideoLink() {
  setTimeout(function() {
    $('#home-banner-iframe').attr('src',$('#hidden-iframe-url').text());
  }, 3000);
}
